import { useTypesStore } from "../store/Types.js";
import { useTypesRender } from "../utils/useRender.js";
export var Map = props => {
  var {
    Map: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Map');
  return null;
};
Map.displayName = 'JVR.Map';